// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 169 ? "3fb82539" : chunkId) + "." + {"139":"e0b8da9815ba2cf2","169":"6681523b32e968dd","828":"db05907d292ad1c9","865":"b9af73baa5192270"}[chunkId] + ".js";
};